import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import useAuthStore from "@Store/authStore";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import { useLogin } from "./LoginQuery.tsx";
import { queryClient } from "../../../apiService/Client";
import NotificationService from "../../../services/NotificationService";
import { queryKeys } from "@Constants/queryKeys.ts";

export default function useLoginContainer() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setUserAuthentication } = useAuthStore();

  const onLoginSuccess = (data: any) => {
    const authPayload =
      data?.data?.body ?? data?.data ?? data?.userData ?? data;
    const normalizedToken = authPayload?.token ?? authPayload?.accessToken;
    if (!normalizedToken) {
      NotificationService.error("Invalid credentials");
      return;
    }
    const normalizedPayload = {
      ...authPayload,
      token: normalizedToken,
      userData: data?.body?.user,
    };
    setUserAuthentication(normalizedPayload);
    queryClient.invalidateQueries({ queryKey: [queryKeys.userManagement.profile] });
    
    navigate(NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD);
  };

  const { mutate: loginMutate, isPending: isLoggingIn } = useLogin({
    onSuccess: onLoginSuccess,
  });

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        role: "admin",
      };
      loginMutate(payload);
    } catch {
      NotificationService.error("Login failed");
    }
    
  };
  const handleSignUp = () => {
    navigate(NavigationRoutes.AUTH_ROUTES.REGISTER);
  };

  const handleForgotPassword = () => {
    navigate(NavigationRoutes.AUTH_ROUTES.FORGOT_PASSWORD);
  };
  return {
    form,
    navigate,
    handleSubmit,
    handleSignUp,
    handleForgotPassword,
    isLoggingIn,
  };
}
